import { createFileRoute } from "@tanstack/react-router";
import { socialImageMeta } from "@/lib/og";
import { LegalLayout, LegalSection } from "@/components/site/LegalLayout";

export const Route = createFileRoute("/villkor")({
  head: () => ({
    meta: [
      { title: "Användarvillkor — Skolvyn" },
      { name: "description", content: "Villkoren för att använda Skolvyn — för familjer, kandidater och skolor." },
      { property: "og:title", content: "Användarvillkor — Skolvyn" },
      { property: "og:description", content: "Så gäller Skolvyn för dig som besökare, medlem och skolkonto." },
    
        ...socialImageMeta({ path: "/villkor" }),
      ],
  }),
  component: Villkor,
});

function Villkor() {
  return (
    <LegalLayout
      eyebrow="Juridik"
      title="Användarvillkor"
      updated="15 juli 2026"
      intro="Dessa villkor gäller mellan dig och Skolvyn AB när du använder skolvyn.se. Läs dem noggrant. Genom att skapa konto eller använda tjänsten godkänner du villkoren."
    >
      <LegalSection id="tjansten" title="Om tjänsten">
        <p>
          Skolvyn är en plattform för att upptäcka, jämföra och kontakta svenska skolor samt för skolor att presentera sig
          som arbetsgivare. Vi förmedlar information men fattar inga beslut om antagning, anställning eller placering.
        </p>
      </LegalSection>

      <LegalSection id="konto" title="Konto och ansvar">
        <ul>
          <li>Du ansvarar för att uppgifterna du lämnar är korrekta och att lösenordet hålls hemligt.</li>
          <li>Konton får endast användas av den person som registrerat dem. Skolkonton får användas av personer med mandat att företräda huvudmannen.</li>
          <li>Du får inte använda tjänsten i strid med lag eller på ett sätt som skadar Skolvyn eller andra användare.</li>
        </ul>
      </LegalSection>

      <LegalSection id="innehall" title="Ditt innehåll">
        <p>
          Du behåller upphovsrätten till det innehåll du publicerar (omdömen, meddelanden, bilder). Du ger Skolvyn en
          icke-exklusiv, avgiftsfri rätt att lagra, visa och tillgängliggöra innehållet i tjänsten. Vi kan moderera eller
          ta bort innehåll som bryter mot våra regler eller lag.
        </p>
      </LegalSection>

      <LegalSection id="omdomen" title="Regler för omdömen">
        <ul>
          <li>Skriv om egen erfarenhet, sakligt och respektfullt.</li>
          <li>Personangrepp, hatiskt språk, känsliga personuppgifter och namngivande av enskilda medarbetare är inte tillåtet.</li>
          <li>Alla omdömen läses av en människa innan de publiceras, normalt inom två arbetsdagar. Du får besked när omdömet publicerats, och om det inte publiceras får du veta varför. Publicerade omdömen kan rapporteras och kan döljas vid överträdelse.</li>
        </ul>
      </LegalSection>

      <LegalSection id="skolkonton" title="Villkor för skolkonton">
        <ul>
          <li>Endast verifierade företrädare får redigera skolans profil, publicera jobb och hantera intresseanmälningar.</li>
          <li>Publicerat innehåll ska vara sanningsenligt och får inte vara vilseledande.</li>
          <li>Betalda funktioner regleras i separat prisbilaga och abonnemangsvillkor.</li>
        </ul>
      </LegalSection>

      <LegalSection id="ansvar" title="Ansvarsbegränsning">
        <p>
          Vi arbetar för att informationen ska vara korrekt men lämnar inga garantier. Skolvyn ansvarar inte för beslut
          som fattas baserat på informationen på sajten, eller för avbrott, förlust av data eller indirekt skada, i den
          utsträckning tvingande lag tillåter.
        </p>
      </LegalSection>

      <LegalSection id="uppsagning" title="Uppsägning">
        <p>
          Du kan när som helst avsluta ditt konto via inställningarna eller genom att kontakta oss. Vi kan stänga av
          konton som bryter mot dessa villkor, efter varning där det är rimligt.
        </p>
      </LegalSection>

      <LegalSection id="lag" title="Tillämplig lag">
        <p>
          Svensk lag tillämpas. Tvist ska i första hand lösas i dialog. Om det inte går kan tvisten prövas av allmän
          domstol, med Stockholms tingsrätt som första instans. Konsumenter har alltid rätt att vända sig till Allmänna
          reklamationsnämnden.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
